export enum PageName {
  FEE_SLIDER = 'fee-slider',
}
